import React, { useEffect } from "react";
import {
  BrowserRouter as Router, Navigate,
  Route, Routes
} from "react-router-dom";

import { Config } from "@cleeng/mediastore-sdk";
import { connect } from "react-redux";
// import { ToastContainer } from "react-toastify";
import "@adyen/adyen-web/dist/adyen.css";
import "react-loading-skeleton/dist/skeleton.css";
import { ToastContainer } from 'react-toastify';
import { ENABLED_MULTIPLE_LANGUAGE, NODE_ENV, PUBLISHER_ID } from "./constants";
import PageNotFound from "./views/404";
import CapturePage from "./views/auth/capture";
import ChoosePlanPage from "./views/auth/choose-plan";
import Login from "./views/auth/login";
import MyAccountPage from "./views/auth/my-account";
import PasswordResetPage from "./views/auth/passwordReset";
import PaymentPage from "./views/auth/payment";
import RegisterPage from "./views/auth/register";
import RedeemGiftPage from "./views/auth/redeem-gift";

import 'react-toastify/dist/ReactToastify.css';
import { LanguageSelect } from "./components/LanguageSelect";
import ManageAccountPage from "./views/auth/manage-account";
import { setCookie } from "./utils";
import DataDeletionPage from "./views/auth/data-deletion";

Config.setPublisher(PUBLISHER_ID);
Config.setEnvironment(NODE_ENV);

function App() {
  useEffect(() => {
    const token = localStorage.getItem("CLEENG_AUTH_TOKEN")
    if (token) {
      setCookie("token", token);
      setCookie("refreshToken", localStorage.getItem("CLEENG_REFRESH_TOKEN"));
      setCookie("customerId", localStorage.getItem("CLEENG_CUSTOMER_ID"));
    }
  }, [])
  return (
    <>
      <div className="container">
        <div className="simple-app">
          <Router>
            <Routes>
              <Route exact path="/" element={<Login />} />
              <Route exact path="/checkout" element={<PaymentPage />} />
              <Route exact path="/choose-plan" element={<ChoosePlanPage />} />
              <Route exact path="/capture" element={<CapturePage />} />
              <Route exact path="/register" element={<RegisterPage />} />
              <Route exact path="/redeem-gift" element={<RedeemGiftPage />} />
              <Route
                exact
                path="/password-reset"
                element={<PasswordResetPage />}
              />
              <Route exact path="/manage-account" element={<ManageAccountPage />} />
              <Route exact path="/data-removal-request" element={<DataDeletionPage />} />
              <Route exact path="/my-account" element={<MyAccountPage />} />
              <Route exact path="/404" element={<PageNotFound />} />
              <Route exact path="*" element={<Navigate to="/404" />} />
            </Routes>
          </Router>
          {ENABLED_MULTIPLE_LANGUAGE && <LanguageSelect />}
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default connect()(App);
